import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-westenergie-storungen',
  templateUrl: './westenergie-storungen.component.html',
  styleUrls: ['./westenergie-storungen.component.scss'],
})
export class WestenergieStorungenComponent {
  @Input() url!: string;
  @Input() isIE11 = false;

  constructor(private _router: Router) {}

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }
}
